(function(){
    'use strict';
    angular.module('Filters')
    .filter('theSameCarrierProfile', ()=>{
        return (data, serviceProfile)=>{
            if(!angular.isUndefined(data)) {
                let filteredData = data.filter(value=>{
                    return value.carrier.carrierId === serviceProfile.carrier.id
                });
                return filteredData;  
            } else {
                return data;
            }
        }
    })
})()


// WEBPACK FOOTER //
// ./js/filters/theSameCarrierOrServiceProfile.js